/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MaterialDto } from '../models/MaterialDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaterialControllerService {
    /**
     * @param uuid
     * @returns MaterialDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<MaterialDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/materials/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns MaterialDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: MaterialDto,
    ): CancelablePromise<MaterialDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/materials/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/materials/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns MaterialDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<MaterialDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/materials',
        });
    }
    /**
     * @param requestBody
     * @returns MaterialDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: MaterialDto,
    ): CancelablePromise<MaterialDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/materials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param value
     * @param fromUnit
     * @param toUnit
     * @returns any OK
     * @throws ApiError
     */
    public static convertUnits(
        value: number,
        fromUnit: 'COUNT' | 'KILOGRAM' | 'GRAM' | 'TON' | 'POUND' | 'OUNCE' | 'LITER' | 'MILLILITER' | 'CUBIC_METER' | 'CUBIC_CENTIMETER' | 'GALLON' | 'METER' | 'CENTIMETER' | 'MILLIMETER' | 'KILOMETER' | 'INCH' | 'FOOT' | 'YARD' | 'SQUARE_METER' | 'SQUARE_CENTIMETER' | 'SQUARE_MILLIMETER' | 'SQUARE_KILOMETER' | 'SQUARE_INCH' | 'SQUARE_FOOT',
        toUnit: 'COUNT' | 'KILOGRAM' | 'GRAM' | 'TON' | 'POUND' | 'OUNCE' | 'LITER' | 'MILLILITER' | 'CUBIC_METER' | 'CUBIC_CENTIMETER' | 'GALLON' | 'METER' | 'CENTIMETER' | 'MILLIMETER' | 'KILOMETER' | 'INCH' | 'FOOT' | 'YARD' | 'SQUARE_METER' | 'SQUARE_CENTIMETER' | 'SQUARE_MILLIMETER' | 'SQUARE_KILOMETER' | 'SQUARE_INCH' | 'SQUARE_FOOT',
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/materials/convert-units',
            query: {
                'value': value,
                'fromUnit': fromUnit,
                'toUnit': toUnit,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getAvailableUnits(): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/materials/units',
        });
    }
    /**
     * @param unitType
     * @returns any OK
     * @throws ApiError
     */
    public static getUnitsByType(
        unitType: string,
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/materials/units/{unitType}',
            path: {
                'unitType': unitType,
            },
        });
    }
    /**
     * @param name
     * @returns MaterialDto OK
     * @throws ApiError
     */
    public static findByName(
        name: string,
    ): CancelablePromise<MaterialDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/materials/by-name/{name}',
            path: {
                'name': name,
            },
        });
    }
}
